<template>
  <custom-dialog width="1200px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body device-detail-log">
      <div class="box-content">
        <div class="api-info">
          <ul class="param-list">
            <li class="param-item">
              <div class="key">{{ $t('base_u8_content_dialog.jie_kou_ming_cheng') }}</div>
              <div class="val">{{ info.myApiName }}</div>
            </li>
            <li class="param-item">
              <div class="key">{{ $t('base_u8_content_dialog.jie_kou_di_zhi') }}</div>
              <div class="val">{{ info.apiUrl }}</div>
            </li>
            <li class="param-item">
              <div class="key">{{ $t('base_u8_content_dialog.zhui_zong_ma') }}</div>
              <div class="val">{{ info.apiTraceId }}</div>
            </li>
            <li class="param-item">
              <div class="key">{{ $t('base_u8_content_dialog.pai_xu') }}</div>
              <div class="val">{{ info.excuteOrder }}</div>
            </li>
            <li class="param-item">
              <div class="key">{{ $t('base_u8_content_dialog.shi_fou_zhi_xing') }}</div>
              <div class="val">{{ getDicValue('isynergy_cloud_bool_true', info.isRuned) }}</div>
            </li>
            <li class="param-item">
              <div class="key">{{ $t('base_u8_content_dialog.zhi_xing_ci_shu') }}</div>
              <div class="val">{{ info.runTimes }}</div>
            </li>
            <li class="param-item">
              <div class="key">{{ $t('base_u8_content_dialog.zhi_xing_jie_guo') }}</div>
              <div class="val">{{ responseJson.code == 1 ? $t('Common.com_success') : $t('Common.com_fail') }}</div>
            </li>
            <li class="param-item">
              <div class="key">{{ $t('base_u8_content_dialog.zhi_xing_shi_jian') }}</div>
              <div class="val">
                {{ momentAmPm($momentLocal(info.gmtCreate)) }}
              </div>
            </li>
          </ul>
        </div>
        <div class="param-content">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>{{ $t('base_u8_content_dialog.ru_can') }}</span>
            </div>
            <div class="text item">
              <pre>{{ JSON.stringify(requestParam, null, 2) }}</pre>
            </div>
          </el-card>

          <el-card class="box-card" style="margin-top:20px">
            <div slot="header" class="clearfix">
              <span>{{ $t('base_u8_content_dialog.fan_hui_jie_guo') }}</span>
            </div>
            <div class="text item">
              <pre>{{ JSON.stringify(responseJson, null, 2) }}</pre>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_close') }}</el-button>
      <el-button v-if="!responseJson.success" @click="onRepush" type="primary">{{ $t('base_u8_content_dialog.chong_xin_diao_yong') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  props: {
    data: [String, Object, Array],
    model: {
      type: Object,
      default() {
        return {
          type: '', // add、edit
          title: ''
        };
      }
    }
  },
  data() {
    return {
      requestParam: {},
      responseJson: {},
      info: {},
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    async onRepush() {
      this.$showConfirm(
        this.$t('base_u8_content_dialog.qdycxdyojkm', [this.info.myApiName])
      ).then(async () => {
        // logsU8Repush
        this.$showLoading();
        try {
          const reqData = [
            this.model.data._id
          ];
          await this.$postJSON(apis.logsU8Repush, reqData);
          await this.getInfo();
        } catch (e) {
          //
        }
        this.$closeLoading();
      });

    },
    // 初始化
    initDialog: function () {
      this.getInfo();
    },
    getInfo: function () {
      return this.$getJSON(`${apis.logsU8Info}/${this.model.data._id}`).then((res) => {
        this.requestParam = res.data.param;
        this.responseJson = res.data.response;
        this.info = res.data;
      });
    }
  }
};
</script>

<style lang="scss">
.device-detail-log {
  pre {
    height: 200px;
    overflow: auto;
  }

  .box-content {
    overflow: hidden;
    display: flex;

    .api-info {
      width: 300px;
      padding-right: 10px;

      .param-item {
        margin-bottom: 15px;
        overflow: hidden;

        .key {
          float: left;
          width: 150px;
        }

        .val {
          overflow: hidden;
          word-break: break-all;
        }
      }
    }

    .param-content {
      flex: 1;
    }
  }
}
</style>
